import { render } from "./add-expense.vue?vue&type=template&id=4aa582db"
import script from "./add-expense.vue?vue&type=script&lang=js"
export * from "./add-expense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__